module.exports = __webpack_public_path__ + "close.png?eed8af40bb965279d7333b4111ad4f65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = 954
// module chunks = 2